import './index.css';
import { useState, useEffect } from 'react';
import { areEqualArrays } from './useExpanded.js';

/**
 * Возвращает массив ID элементов дерева, у которых есть и выбранные, и невыбранные потомки.
 */
function getIndeterminateParentIds(collection, selected) {
    const result = selected.reduce((currentResult, id) => {
        collection.getParentIds(id).forEach((parentId) => {
            if (!selected.includes(parentId)) {
                currentResult.add(parentId);
            }
        });
        return currentResult;
    }, new Set());
    return [...result];
}
const useIndeterminate = ({ collection, selected }) => {
    const [indeterminate, setIndeterminate] = useState([]);
    useEffect(() => {
        const updatedIndeterminateIds = getIndeterminateParentIds(collection, selected);
        setIndeterminate((current) => areEqualArrays(current, updatedIndeterminateIds) ? current : updatedIndeterminateIds);
    }, [selected, collection]);
    return { indeterminate };
};

export { getIndeterminateParentIds, useIndeterminate };
//# sourceMappingURL=useIndeterminate.js.map
